import React, {useState} from "react";
import {message, Upload} from "antd";
import {UploadOutlined, DownloadOutlined} from "@ant-design/icons";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";
import {ExcelButtonsPropTypes} from "./ComponentPropTypes";
import config from "../../../_core/config";
import {b64DecodeToUrl} from "../../../utils/helpers";
import {ExcelButtonsContainer} from "./ComponentStyles";

const ExcelButtons = ({
    skip,
    limit,
    city,
    approveStatus,
    period,
    startDate,
    endDate,
    searchText,
    setReloadData
}: ExcelButtonsPropTypes) => {
    const {t} = useTranslation();
    const stores = useStore();
    const [importLoading, setImportLoading] = useState();

    const fileUploadProps = {
        name: "file",
        multiple: false,
        action: `${config.getReportBasePublicUrl()}api/panel/v1/shifts/day-off/import`,
        headers: {Authorization: "Basic " + stores.meStore.sessionToken},
        showUploadList: false,
        onChange: async info => {
            const {status} = info.file;
            if (status === "uploading") {
                setImportLoading(true);
            }
            if (status === "done") {
                const responseMessages = [];
                const validationMessages = info.file.response.result?.validationMessages;
                let errorExcel = info.file.response.result?.errorExcel;
                if (errorExcel) {
                    responseMessages.push(
                        <div key={"error"}>
                            <b>
                                {t("companyDetail.modal.fileUpload.errorExcel", {
                                    ns: "companyDetail"
                                })}
                            </b>
                        </div>
                    );
                    errorExcel = await b64DecodeToUrl(errorExcel);
                    let link = document.createElement("a");
                    link.href = errorExcel;
                    link.download = `${t("screens.shiftManagement", {ns: "common"})}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function() {
                        window.URL.revokeObjectURL(link);
                    }, 200);
                }

                for (const message of validationMessages) {
                    responseMessages.push(<div key={message}>{message}</div>);
                }
                stores.appStore.openSuccessModal({
                    title: t("companyDetail.modal.fileUpload.success", {ns: "companyDetail"}),
                    content: responseMessages
                });
                setReloadData();
                setImportLoading(false);
            } else if (status === "error") {
                message.error(
                    t("companyDetail.modal.fileUpload.error", {
                        ns: "companyDetail",
                        filename: info.file.name,
                        responseMessage: info.file.response.message
                    })
                );
                setImportLoading(false);
            }
        }
    };

    return (
        <React.Fragment>
            <CustomButton
                type="primary"
                data-testid="exportWithExcelButton"
                onClick={async () => {
                    const data = {
                        skip,
                        limit,
                        city,
                        approveStatus,
                        period,
                        startDate,
                        endDate,
                        searchText
                    };
                    const response = await stores.shiftStore.downloadDayOffExcelFile(data);
                    let link = document.createElement("a");
                    link.href = response;
                    link.download = `${t("screens.dayOff", {ns: "common"})}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function() {
                        window.URL.revokeObjectURL(link);
                    }, 200);
                }}
                icon={<DownloadOutlined />}
            >
                {t("companyDetail.actions.exportWithExcel", {
                    ns: "companyDetail"
                })}
            </CustomButton>
            <Upload {...fileUploadProps} accept=".xlsx,.xls,.csv,.tsv">
                <CustomButton
                    loading={importLoading}
                    icon={<UploadOutlined />}
                    data-testid="importFromExcelButton"
                >
                    {t("companyDetail.actions.importFromExcel", {
                        ns: "companyDetail"
                    })}
                </CustomButton>
            </Upload>
            <CustomButton
                href={`${process.env.PUBLIC_URL}/import-templates/day-off-template.xlsx`}
                type="ghost"
                icon={<DownloadOutlined />}
                data-testid="downloadExcelTemplete"
            >
                {t("companyDetail.actions.downloadExcelTemplate", {ns: "companyDetail"})}
            </CustomButton>
        </React.Fragment>
    );
};

export default ExcelButtons;
